
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "@/hooks/use-toast";

interface RegisterFormProps {
  redirectPath: string;
}

const RegisterForm: React.FC<RegisterFormProps> = ({ redirectPath }) => {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsRegistering(true);

    try {
      console.log("Début inscription avec options:", { 
        full_name: fullName
      });
      
      // Par défaut, tous les utilisateurs sont créés avec le rôle "individual"
      const { error } = await signUp(
        email, 
        password, 
        { 
          full_name: fullName,
          role: 'individual', // Updated from 'candidat' to 'individual'
          organization: '',
          website_url: ''
        }
      );

      if (error) {
        console.error("Erreur d'inscription détaillée:", error);
        toast({
          title: "Erreur d'inscription",
          description: error.message || "Vérifiez vos informations et réessayez.",
          variant: "destructive"
        });
      } else {
        toast({
          title: "Inscription réussie",
          description: "Votre compte a été créé avec succès.",
        });
        navigate(redirectPath, { replace: true });
      }
    } catch (error: any) {
      console.error("Exception lors de l'inscription:", error);
      toast({
        title: "Erreur d'inscription",
        description: error.message || "Une erreur est survenue. Veuillez réessayer.",
        variant: "destructive"
      });
    } finally {
      setIsRegistering(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Inscription</CardTitle>
        <CardDescription>
          Créez un compte pour accéder à toutes les fonctionnalités.
        </CardDescription>
      </CardHeader>
      <form onSubmit={handleRegister}>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="register-email">Email</Label>
            <Input
              id="register-email"
              type="email"
              placeholder="votre@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="register-full-name">Nom complet</Label>
            <Input
              id="register-full-name"
              type="text"
              placeholder="Prénom Nom"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="register-password">Mot de passe</Label>
            <Input
              id="register-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <p className="text-sm text-muted-foreground">
            Vous pourrez activer différents types de profils dans votre espace personnel après l'inscription.
          </p>
        </CardContent>
        <CardFooter>
          <Button type="submit" className="w-full" disabled={isRegistering}>
            {isRegistering ? 'Inscription en cours...' : 'S\'inscrire'}
          </Button>
        </CardFooter>
      </form>
    </Card>
  );
};

export default RegisterForm;
